//#region src/v2/blocks/scalar-auth-selector-block/helpers/oauth2-metadata-to-flows.ts
/** Supplements declared endpoints while preserving explicit scopes, including empty scope sets. */
var oauth2MetadataToFlows = (metadata, flows) => {
	const scopes = Object.fromEntries((metadata.scopes_supported ?? []).map((scope) => [scope, ""]));
	const grants = new Set(metadata.grant_types_supported ?? ["authorization_code", "implicit"]);
	const authorizationUrl = metadata.authorization_endpoint;
	const tokenUrl = metadata.token_endpoint;
	const deviceAuthorizationUrl = metadata.device_authorization_endpoint;
	const discovered = {
		...grants.has("urn:ietf:params:oauth:grant-type:device_code") && deviceAuthorizationUrl && tokenUrl ? { deviceAuthorization: {
			deviceAuthorizationUrl,
			tokenUrl,
			scopes
		} } : {},
		...grants.has("implicit") && authorizationUrl ? { implicit: {
			authorizationUrl,
			scopes
		} } : {},
		...grants.has("password") && tokenUrl ? { password: {
			tokenUrl,
			scopes
		} } : {},
		...grants.has("client_credentials") && tokenUrl ? { clientCredentials: {
			tokenUrl,
			scopes
		} } : {},
		...grants.has("authorization_code") && authorizationUrl && tokenUrl ? { authorizationCode: {
			authorizationUrl,
			tokenUrl,
			scopes
		} } : {}
	};
	if (!Object.keys(flows).length) return discovered;
	return Object.fromEntries(Object.entries(flows).filter(([, flow]) => flow).map(([key, flow]) => [key, {
		..."authorizationUrl" in flow && !flow.authorizationUrl && authorizationUrl ? { authorizationUrl } : {},
		..."deviceAuthorizationUrl" in flow && !flow.deviceAuthorizationUrl && deviceAuthorizationUrl ? { deviceAuthorizationUrl } : {},
		..."tokenUrl" in flow && !flow.tokenUrl && tokenUrl ? { tokenUrl } : {}
	}]).filter(([, update]) => Object.keys(update).length > 0));
};
//#endregion
export { oauth2MetadataToFlows };

//# sourceMappingURL=oauth2-metadata-to-flows.js.map